import { render, staticRenderFns } from "./StatusButton.vue?vue&type=template&id=4c84cbb0"
import script from "./StatusButton.vue?vue&type=script&lang=js"
export * from "./StatusButton.vue?vue&type=script&lang=js"
import style0 from "./StatusButton.vue?vue&type=style&index=0&id=4c84cbb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.29_css-loader@3.6.0_webpack@4.47.0__ejs@3.1.10_66cafdebd9b3647e04b2d113c5f27dd4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports